import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DContext } from "../../context/Datacontext";
import { Loader, ExternalLink } from "lucide-react";


export const RecuriterStatus = () => {
    const { BeURL } = useContext(DContext);
    const navigate = useNavigate()
    const { jobId } = useParams();
    const [searchParams] = useSearchParams();
    const  tableRef = useRef(null);
    const fromDate = searchParams.get("from");
    const toDate = searchParams.get("to");

    console.log("toDate",{fromDate ,toDate})



    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [status, setStatus]=useState([])

        const fetchStatus = useCallback(async () => {
            try {
                const response = await fetch(`${BeURL}/allStatus`, {
                    method: "GET",
                    credentials: "include",
                });
                const result = await response.json();
                if (result.success) {
                    setStatus(result.status);
                } else {
                    console.log(result.message);
                }
            } catch (err) {
                console.log("Error fetching status:", err);
            }
        }, [BeURL]);
    
        useEffect(() => {
            fetchStatus();
        }, [fetchStatus]);

    const fetchRecruiter = useCallback(async () => {
        try {
            setLoading(true);
            const response = await fetch(
                `${BeURL}/recuriter-status/${jobId}?fromDate=${fromDate}&toDate=${toDate}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const result = await response.json();
            if (result.success) {
                setData(result.data);
            } else {
                console.log(result.message);
            }
        } catch (error) {
            console.error("Error fetching recruiter:", error);
        } finally {
            setLoading(false);
        }
    }, [BeURL, jobId ,fromDate ,toDate]);

    useEffect(() => {
        fetchRecruiter();
    }, [fetchRecruiter]);


    const handleRecruiterStatus = (recuriterId) => {
        navigate(`/candidate-profile/${jobId}/${recuriterId}?from=${fromDate}&to=${toDate}`)
    }






    const groupColors = {
        "Screening": "bg-yellow-500",
        "Level 1 Interview": "bg-green-600",
        "Level 2 Interview": "bg-yellow-500",
        "Level 3 Interview": "bg-purple-600",
        "Client Round": "bg-pink-600",
        "BGV": "bg-indigo-600",
        "Offer Status": "bg-green-600",
        "Drop": "bg-red-600",
    };


    const groupedStatus = status.reduce((acc, item) => {
        if (!acc[item.group]) {
            acc[item.group] = [];
        }
        acc[item.group].push(item);
        return acc;
    }, {});





        useEffect(() => {
            const slider = tableRef.current;
    
            let isDown = false;
            let startX;
            let scrollLeft;
    
            const mouseDown = (e) => {
                isDown = true;
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
                slider.style.cursor = "grabbing";
            };
    
            const mouseLeave = () => {
                isDown = false;
                slider.style.cursor = "grab";
            };
    
            const mouseUp = () => {
                isDown = false;
                slider.style.cursor = "grab";
            };
    
            const mouseMove = (e) => {
                if (!isDown) return;
                e.preventDefault();
    
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 2;
                slider.scrollLeft = scrollLeft - walk;
            };
    
            slider.addEventListener("mousedown", mouseDown);
            slider.addEventListener("mouseleave", mouseLeave);
            slider.addEventListener("mouseup", mouseUp);
            slider.addEventListener("mousemove", mouseMove);
    
            return () => {
                slider.removeEventListener("mousedown", mouseDown);
                slider.removeEventListener("mouseleave", mouseLeave);
                slider.removeEventListener("mouseup", mouseUp);
                slider.removeEventListener("mousemove", mouseMove);
            };
        }, []);




    return (
        <div className="p-4 overflow-auto min-h-[85vh] mt-5">
            {loading && (
                <Loader />
            )}
            <div ref={tableRef} className="overflow-x-auto cursor-grab">
            <table className="min-w-max border border-gray-300 text-xs">
                <thead className="bg-primary-500 text-white">
                    {/* Group Header */}
                    <tr >
                        
                            <th
                                rowSpan={2}
                                className="sticky left-0 z-30 bg-primary-500 border px-3 py-2 text-left min-w-[220px]"
                            >
                                Recruiter
                            </th>

                        <th
                            rowSpan={2}
                            className="border px-3 py-2 "
                        >
                            Profiles
                        </th>

                        {Object.entries(groupedStatus).map(([group, items]) => (
                            <th
                                key={group}
                                colSpan={items.length}
                                className={`border px-3 py-1 text-white ${groupColors[group] || "bg-gray-600"
                                    }`}
                            >
                                {group}
                            </th>
                        ))}
                    </tr>

                    {/* Status Header */}
                    <tr>
                        {Object.values(groupedStatus)
                            .flat()
                            .map((sts) => (
                                <th
                                    key={sts._id}
                                    className="border px-3 py-2 whitespace-nowrap"
                                >
                                    {sts.status}
                                </th>
                            ))}
                    </tr>
                </thead>

                <tbody>
                    {data.map((recruiter,idx) => (
                        <tr key={idx}>
                            <td className="sticky left-0 z-20 bg-white border px-3 py-2 font-medium min-w-[220px]">
                                <div className="flex items-center space-x-2">
                                    <button
                                        type="button"
                                        className="text-primary-500"
                                        onClick={() => handleRecruiterStatus(recruiter.recruiterId)}
                                    >
                                        <ExternalLink size={16} />
                                    </button>

                                    <span className="bg-secondary-500 w-0.5 h-5"></span>

                                    <span>{recruiter.recruiterName}</span>
                                </div>
                            </td>

                            <td className="border px-3 py-2 text-center font-semibold">
                                {recruiter.profileCount}
                            </td>

                            {Object.values(groupedStatus)
                                .flat()
                                .map((sts) => {
                                    const key = sts.status
                                        .trim()
                                        .toLowerCase()
                                        .replace(/\s+/g, " ");

                                    const value =
                                        recruiter.statusCounts?.[key] || {
                                            count: 0,
                                            duplicate: 0,
                                        };

                                    return (
                                        <td
                                            key={sts._id}
                                            className="border px-2 py-2 text-center"
                                        >
                                            {value.duplicate > 0
                                                ? `${value.count} (${value.duplicate})`
                                                : value.count}
                                        </td>
                                    );
                                })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        </div>
    );
}